import React, { useEffect, useRef, useState } from "react";
import SidebarItem from "./sidebar-item";
import { Link, useLocation } from "react-router-dom";
import { Image } from "react-bootstrap";
import { SidebarContent } from "../../constants/layout/sidebar";
import { useSelector } from "react-redux";
import "./sidebar.css";

export default function Sidebar({ className }) {
  const credits = useSelector((state) => state.auth.user?.credits);
  const user = useSelector((state) => state.auth.user);

  // An item may declare a flag on the signed-in account that has to be true
  // before it appears at all.
  const menu = SidebarContent.filter(
    (item) => !item.requires || Boolean(user?.[item.requires])
  );

  const [scrolled, setScrolled] = useState(false);
  const sidebarRef = useRef(null);

  const location = useLocation();

  const handleSidebarScroll = () => {
    const scrollPosition = sidebarRef.current.scrollTop;

    if (scrollPosition > 1) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    const sidebar = sidebarRef.current;
    if (sidebar) {
      sidebar.addEventListener("scroll", handleSidebarScroll);
    }
    return () => {
      if (sidebar) {
        sidebar.removeEventListener("scroll", handleSidebarScroll);
      }
    };
  }, []);

  
  return (
    <>
      <aside className={`bg-white ${className} sidebar`}>
        <div className="h-100 position-relative d-flex flex-column">
          <div className="flex-shrik-1 position-relative">
            <div
              className={`d-flex align-items-center justify-content-center position-sticky top-0 start-0 end-0 site-logo ${scrolled ? "effect-logo" : null
                }`}
            >
              <Link to="/dashboard">
                <h1>
                  <Image src="/assets/images/logo/logo-black.svg" />
                </h1>
              </Link>
            </div>
          </div>
          <div className="py-1 flex-grow-1 overflow-y-auto" ref={sidebarRef}>
            <ul className="mb-0 list-unstyled">
              {menu.map((item, i) => {
                // console.log("item :: ", item?.link);
                return (
                  <SidebarItem
                    key={i}
                    to={item.link}
                    icon={item.icon}
                    title={item.title}
                    className={
                      location.pathname.includes(item.link) ? "active" : null
                    }
                  // className={
                  //   location.pathname === item.link ? "active" : null
                  // }
                  />
                );
              })}
            </ul>
          </div>
          <div className="position-sticky bottom-0 mb-5 credit-card px-4 w-100 ">
            <div className="border rounded-2 p-3 position-relative">
              <p>Available Credits</p>
              <h5 className="mt-2">{credits}</h5>
              <div className="bg____img-015"></div>
              {/* <span>Available Credits:{credits}</span> */}
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}
